import React, { FC, useMemo, useCallback, useRef, useState } from 'react'
import { Center, useRadio, Flex /*useBreakpointValue*/ } from '@chakra-ui/react'
import { Box, Image, Text } from '../index'
import { RadioButtonProps } from './interfaces'
import { logoImageMap } from '../../state/interfaces'
import { RadioButton } from './radio-button'
import theme from '../../styles'

export const MixedLargePillRadioButton: FC<RadioButtonProps> = (props) => {
  const { getInputProps, getRadioProps } = useRadio({ ...props, value: props.value?.toString() })
  const image = useMemo(() => (props.image ? logoImageMap[props.image] : ''), [props])
  // const blueImage = useMemo(() => (props.blueImage ? logoImageMap[props.blueImage] : ''), [props])
  const inputRef = useRef<HTMLInputElement>(null)
  // const [isHovered, setIsHovered] = useState(false)
  // const [isHoverImageLoaded, setIsHoverImageLoaded] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  // const isDesktop = useBreakpointValue({ base: false, lg: true })

  const handleMouseEnter = useCallback(() => {
    if (isClicked) {
      return
    }
    // setIsHovered(true)
  }, [])

  const handleMouseLeave = useCallback(() => {
    if (isClicked) {
      return
    }
    // setIsHovered(false)
  }, [])

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  const handleClick = useCallback((event: React.MouseEvent) => {
    setIsClicked(true)
    event.stopPropagation()
  }, [])

  // const handleHoverImageLoad = () => {
  //   setIsHoverImageLoaded(true)
  // }

  return (
    <>
      {image ? (
        <Flex as="label" cursor="pointer" data-testid={`pill-${props.value}`} display="flex" justifyContent="center">
          <Center
            {...getRadioProps()}
            width={['100px', '130px']}
            height={['90px', '110px']}
            maxWidth={105}
            margin={2}
            padding={2}
            border="3px solid #D8D8D8"
            borderStyle="solid"
            borderRadius="lg"
            backgroundColor="white"
            _hover={{
              borderColor: 'brand',
              boxShadow: '0 0 0 2px #5bce4c',
            }}
            _checked={{
              borderColor: 'brand',
            }}
            _focus={{
              borderColor: 'brand',
              boxShadow: '0 0 0 2px #5bce4c',
            }}
            tabIndex={0}
            onFocus={handleFocus}
            onClick={(event) => handleClick(event)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className="image-container"
          >
            <RadioButton {...getInputProps()} ref={inputRef} />

            <Image src={image} /*onLoad={handleHoverImageLoad}*/ />
            {/* {isHovered || !isDesktop ? (
              <Image src={image} onLoad={handleHoverImageLoad} className={isHoverImageLoaded ? 'visible' : 'hidden'} />
            ) : (
              <Image src={blueImage} className={!isHovered ? 'visible' : 'hidden'} />
            )} */}
            <Text marginTop={4}>{props.label}</Text>
          </Center>
        </Flex>
      ) : (
        <Box style={{ width: '100%' }} display="flex" justifyContent="center">
          <Box as="label" cursor="pointer" data-testid={`pill-${props.value}`} justifyContent="center">
            <Center {...getRadioProps()} tabIndex={0} onFocus={handleFocus} layerStyle={theme.LayerStyles.LARGE_PILL}>
              <RadioButton {...getInputProps()} ref={inputRef} />
              <Text>{props.label}</Text>
            </Center>
          </Box>
        </Box>
      )}
    </>
  )
}
